module.exports = __webpack_public_path__ + "media/Dokumentation_Universum.c9fca7a7.mp3";